import React, { useEffect, useState } from 'react';
import api from '../../utils/api';

const AdjustUserCreditsForm = () => {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({
    user_id: '',
    amount_added: 0,
    type: 'add',
    reason: '',
    admin_id: 1,
  });
  const [message, setMessage] = useState('');

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await api.get('/api/users');
        setUsers(res.data);
      } catch (err) {
        console.error('Error al cargar usuarios:', err);
      }
    };
    fetchUsers();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');

    try {
      await api.post('/api/credits', {
        ...form,
        amount_added: parseInt(form.amount_added, 10),
      });
      setMessage('✅ Créditos actualizados correctamente');
      setForm({ user_id: '', amount_added: 0, type: 'add', reason: '', admin_id: 1 });
    } catch (err) {
      console.error(err);
      setMessage('❌ Error al actualizar créditos');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-5 text-sm">
      <div>
        <label className="block text-gray-700 font-medium mb-1">Seleccionar usuario</label>
        <select
          name="user_id"
          value={form.user_id}
          onChange={handleChange}
          required
          className="w-full border border-gray-300 rounded-md px-3 py-2 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-600"
        >
          <option value="">Selecciona un usuario...</option>
          {users.map((user) => (
            <option key={user.id} value={user.id}>
              {user.full_name} ({user.email})
            </option>
          ))}
        </select>
      </div>

      <div className="flex gap-4">
        <div className="flex-1">
          <label className="block text-gray-700 font-medium mb-1">Cantidad</label>
          <input
            type="number"
            name="amount_added"
            value={form.amount_added}
            onChange={handleChange}
            min={1}
            required
            className="w-full border border-gray-300 rounded-md px-3 py-2 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-600"
          />
        </div>
        <div className="flex-1">
          <label className="block text-gray-700 font-medium mb-1">Tipo</label>
          <select
            name="type"
            value={form.type}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-md px-3 py-2 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-600"
          >
            <option value="add">Agregar</option>
            <option value="subtract">Quitar</option>
          </select>
        </div>
      </div>

      <div>
        <label className="block text-gray-700 font-medium mb-1">Motivo (opcional)</label>
        <textarea
          name="reason"
          value={form.reason}
          onChange={handleChange}
          rows="3"
          className="w-full border border-gray-300 rounded-md px-3 py-2 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-600"
        />
      </div>

      <button
        type="submit"
        className="w-full bg-blue-700 text-white rounded-md py-2 hover:bg-blue-800 transition-all font-medium"
      >
        Confirmar Ajuste
      </button>

      {message && (
        <p className={`text-center mt-3 ${message.startsWith('✅') ? 'text-green-600' : 'text-red-600'}`}>
          {message}
        </p>
      )}
    </form>
  );
};

export default AdjustUserCreditsForm;
